import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getEntityIncidents, chatWithData } from "../../api";
import ChatComponent from '../ChatComponent';
const EntityIncidentList = () => {
  const [incidents, setIncidents] = useState([]);
  const [searchType, setSearchType] = useState(""); // Search by entityId, triggerId, etc.
  const [searchValue, setSearchValue] = useState(""); // Search input value
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [totalRecords, setTotalRecords] = useState(0); // Total number of records
  const navigate = useNavigate();

  useEffect(() => {
    fetchIncidents();
  }, [page, rowsPerPage]);

  const fetchIncidents = async () => {
    try {
      const params = {
        page: page + 1,
        limit: rowsPerPage,
      };
      if (searchType && searchValue) {
        params[searchType] = searchValue;
      }
      const response = await getEntityIncidents(params);
      setIncidents(response.data.data);
      setTotalRecords(response.data.total);
    } catch (error) {
      console.error("Error fetching incidents:", error);
    }
  };

  const handleSearch = () => {
    setPage(0);
    fetchIncidents();
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewIncident = (id) => {
    navigate(`/entity-incident/${id}`);
  };

  const preprocessedData = useMemo(() => {
    return incidents.map(incident => {
      return incident

    });
  }, [incidents]);

  return (
    <Box p={3} maxWidth={1200} mx="auto">
      <ChatComponent data={preprocessedData} queryApi={chatWithData} />
      <Typography variant="h5" mb={3}>
        Incident List
      </Typography>
      <Box display="flex" gap={2} mb={3}>
        <FormControl fullWidth>
          <InputLabel>Search By</InputLabel>
          <Select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
          >
            <MenuItem value="entityId">Entity ID</MenuItem>
            <MenuItem value="triggerId">Trigger ID</MenuItem>
            <MenuItem value="sensorData">Sensor Data</MenuItem>
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Search Value"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <Button variant="contained" color="primary" onClick={handleSearch}>
          Search
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Entity Name</TableCell>
              <TableCell>Trigger Name</TableCell>
              <TableCell>Sensor Data</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {incidents.map((incident) => (
              <TableRow key={incident._id}>
                <TableCell>{incident._id}</TableCell>
                <TableCell>{incident.entityInfo?.name}</TableCell>
                <TableCell>{incident.trigger?.name}</TableCell>
                <TableCell>{JSON.stringify(incident.sensorData?.data)}</TableCell>
                <TableCell>
                  {new Date(incident.createdAt).toLocaleString()}
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleViewIncident(incident._id)}
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalRecords}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Box>
  );
};

export default EntityIncidentList;
